"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObfuscationResult = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const ICryptUtils_1 = require("../interfaces/utils/ICryptUtils");
const IGlobalIdentifierNamesCacheStorage_1 = require("../interfaces/storages/identifier-names-cache/IGlobalIdentifierNamesCacheStorage");
const IPropertyIdentifierNamesCacheStorage_1 = require("../interfaces/storages/identifier-names-cache/IPropertyIdentifierNamesCacheStorage");
const IOptions_1 = require("../interfaces/options/IOptions");
const Initializable_1 = require("../decorators/Initializable");
const SourceMapMode_1 = require("../enums/source-map/SourceMapMode");
let ObfuscationResult = class ObfuscationResult {
    constructor(cryptUtils, globalIdentifierNamesCacheStorage, propertyIdentifierNamesCacheStorage, options) {
        this.cryptUtils = cryptUtils;
        this.globalIdentifierNamesCacheStorage = globalIdentifierNamesCacheStorage;
        this.propertyIdentifierNamesCacheStorage = propertyIdentifierNamesCacheStorage;
        this.options = options;
    }
    initialize(obfuscatedCode, sourceMap) {
        this.obfuscatedCode = obfuscatedCode;
        this.sourceMap = sourceMap;
    }
    getIdentifierNamesCache() {
        if (!this.options.identifierNamesCache) {
            return null;
        }
        return {
            globalIdentifiers: this.globalIdentifierNamesCacheStorage.getStorageAsDictionary(),
            propertyIdentifiers: this.propertyIdentifierNamesCacheStorage.getStorageAsDictionary()
        };
    }
    getObfuscatedCode() {
        return this.correctObfuscatedCode();
    }
    getOptions() {
        return this.options;
    }
    getSourceMap() {
        return this.sourceMap;
    }
    toString() {
        return this.obfuscatedCode;
    }
    correctObfuscatedCode() {
        if (!this.sourceMap) {
            return this.obfuscatedCode;
        }
        const sourceMapUrl = this.options.sourceMapBaseUrl + this.options.sourceMapFileName;
        let sourceMappingUrl = '//# sourceMappingURL=';
        switch (this.options.sourceMapMode) {
            case SourceMapMode_1.SourceMapMode.Inline:
                sourceMappingUrl += `data:application/json;base64,${this.cryptUtils.btoa(this.sourceMap)}`;
                break;
            case SourceMapMode_1.SourceMapMode.Separate:
            default:
                if (!sourceMapUrl) {
                    return this.obfuscatedCode;
                }
                sourceMappingUrl += sourceMapUrl;
        }
        return `${this.obfuscatedCode}\n${sourceMappingUrl}`;
    }
};
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", String)
], ObfuscationResult.prototype, "obfuscatedCode", void 0);
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", String)
], ObfuscationResult.prototype, "sourceMap", void 0);
ObfuscationResult = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.ICryptUtils)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IGlobalIdentifierNamesCacheStorage)),
    __param(2, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IPropertyIdentifierNamesCacheStorage)),
    __param(3, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof ICryptUtils_1.ICryptUtils !== "undefined" && ICryptUtils_1.ICryptUtils) === "function" ? _a : Object, typeof (_b = typeof IGlobalIdentifierNamesCacheStorage_1.IGlobalIdentifierNamesCacheStorage !== "undefined" && IGlobalIdentifierNamesCacheStorage_1.IGlobalIdentifierNamesCacheStorage) === "function" ? _b : Object, typeof (_c = typeof IPropertyIdentifierNamesCacheStorage_1.IPropertyIdentifierNamesCacheStorage !== "undefined" && IPropertyIdentifierNamesCacheStorage_1.IPropertyIdentifierNamesCacheStorage) === "function" ? _c : Object, typeof (_d = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _d : Object])
], ObfuscationResult);
exports.ObfuscationResult = ObfuscationResult;
